module.exports = function (data) {
    return {
        event: 'BWSArticleVote',
        eventContext: {
            linkName: data.linkName
        }
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/help-center/article-vote-mapper.js
 **/